import moment from 'moment';

import { NavType } from '../../components/NavigationRoutes/constants';

export const findNearestPointByTime = (points = [], timeForCheck, nowUTC) => {
    const hash = new Map();
    const times = [];
    const preparedPoints = points
        .reduce((accum, point, i) => {
            if (!point.routeNumber && +point.type !== NavType.COMMENT && +point.type !== NavType.ALTITUDE) {
                point.pos = i;
                accum.push(point);
            }

            return accum;
        }, [])
        .sort((pointA, pointB) => pointB.pointNumber - pointA.pointNumber);

    const hashedPosByTimes = { times, hash };
    let timeDiff;
    for (let i = 0; i < preparedPoints.length - 1; i++) {
        timeDiff = moment(preparedPoints[i].ato || preparedPoints[i][timeForCheck]).diff(nowUTC, 'milliseconds');
        hashedPosByTimes.times.push(timeDiff);
        hashedPosByTimes.hash.set(timeDiff, preparedPoints[i].pos);
        if (timeDiff <= 0) {
            break;
        }
    }

    const minDiff = Math.min(...hashedPosByTimes.times);
    const pos = hashedPosByTimes.hash.get(minDiff);
    const currentPoint = points[pos];

    return { point: currentPoint, pos };
};
